// src/website/GlobalComponents/Header.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import LogoB from "../assets/images/LogoB.png";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  return (
    <header style={styles.header}>
      {/* Top utility bar */}
      <div style={isMobile ? styles.topBarMobile : styles.topBar}>
        <span style={isMobile ? styles.topBarEmail : styles.topBarLeft}>
          info@mujiconsulting.co.za
        </span>
      </div>

      {/* Main navigation */}
      <nav style={isMobile ? styles.navMobile : styles.nav} aria-label="Main">
        {/* Logo */}
        <div style={styles.logo} onClick={() => navigate("/")}>
          <img
            src={LogoB}
            alt="Lebowakgomo Dry Cleaners"
            style={isMobile ? styles.logoImageMobile : styles.logoImage}
          />
        </div>

        {/* Desktop Navigation Links – Projects removed */}
        {!isMobile && (
          <div style={styles.navLinks}>
            <Link to="/" style={styles.navLink}>Home</Link>
            <Link to="/about" style={styles.navLink}>About</Link>
            <Link to="/careers" style={styles.navLink}>Careers</Link>
            <Link to="/services" style={styles.navLink}>Services</Link>
          </div>
        )}

        {/* Desktop Contact Button */}
        {!isMobile && (
          <Link to="/contact" style={styles.contactButton}>Contact</Link>
        )}

        {/* Mobile Icons */}
        {isMobile && (
          <div style={styles.mobileNav}>
            <button
              type="button"
              style={styles.mobileMenuButton}
              onClick={toggleMobileMenu}
              aria-label="Menu"
            >
              {mobileMenuOpen ? (
                <FaTimes style={{ fontSize: "18px" }} />
              ) : (
                <FaBars style={{ fontSize: "18px" }} />
              )}
            </button>
          </div>
        )}
      </nav>

      {/* Mobile Menu Drawer – Projects removed */}
      {mobileMenuOpen && isMobile && (
        <div style={styles.mobileOverlay} onClick={toggleMobileMenu}>
          <div style={styles.mobileMenu} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeButton} onClick={toggleMobileMenu}>
              <FaTimes style={{ fontSize: "16px" }} />
            </button>
            <div style={styles.mobileLinks}>
              <Link to="/" style={styles.mobileLink} onClick={toggleMobileMenu}>Home</Link>
              <Link to="/about" style={styles.mobileLink} onClick={toggleMobileMenu}>About</Link>
              <Link to="/careers" style={styles.mobileLink} onClick={toggleMobileMenu}>Careers</Link>
              <Link to="/services" style={styles.mobileLink} onClick={toggleMobileMenu}>Services</Link>
              <Link to="/contact" style={styles.mobileContactLink} onClick={toggleMobileMenu}>Contact</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

const styles = {
  header: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    background: "#FFFFFF",
    color: "#1E2A3A",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },

  /* ── Top bar – desktop ── */
  topBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "9px 20px",
    fontSize: "13px",
    backgroundColor: "#1E2A3A",
    color: "#FFFFFF",
  },
  topBarLeft: {
    fontWeight: "500",
    letterSpacing: "0.4px",
  },

  /* ── Top bar – mobile ── */
  topBarMobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "7px 16px",
    fontSize: "11px",
    backgroundColor: "#1E2A3A",
    color: "#FFFFFF",
  },
  topBarEmail: {
    fontWeight: "400",
    color: "rgba(255,255,255,0.75)",
    letterSpacing: "0.2px",
  },

  /* ── Nav – desktop ── */
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },

  /* ── Nav – mobile ── */
  navMobile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 14px",
    width: "100%",
    boxSizing: "border-box",
  },

  /* ── Logo ── */
  logo: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  logoImage: {
    height: "64px",
    width: "auto",
    maxWidth: "100%",
    objectFit: "contain",
  },
  logoImageMobile: {
    height: "44px",
    width: "auto",
    maxWidth: "160px",
    objectFit: "contain",
  },

  /* ── Desktop nav links ── */
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
  },
  navLink: {
    color: "#1E2A3A",
    textDecoration: "none",
    fontSize: "17px",
    fontWeight: "500",
    transition: "color 0.2s",
  },
  contactButton: {
    border: "2px solid #2C6B8F",
    borderRadius: "6px",
    padding: "10px 24px",
    color: "#2C6B8F",
    textDecoration: "none",
    fontSize: "17px",
    fontWeight: "600",
    transition: "all 0.2s",
    backgroundColor: "transparent",
  },

  /* ── Mobile icon row ── */
  mobileNav: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  mobileMenuButton: {
    background: "none",
    border: "none",
    color: "#1E2A3A",
    fontSize: "18px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: "6px",
  },

  /* ── Mobile drawer ── */
  mobileOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 200,
    display: "flex",
    justifyContent: "flex-end",
  },
  mobileMenu: {
    width: "240px",
    height: "100%",
    backgroundColor: "#1E2A3A",
    padding: "20px",
    position: "relative",
  },
  closeButton: {
    background: "none",
    border: "none",
    color: "#FFFFFF",
    fontSize: "20px",
    position: "absolute",
    top: "14px",
    right: "14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  mobileLinks: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    marginTop: "44px",
  },
  mobileLink: {
    color: "#FFFFFF",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "500",
  },
  mobileContactLink: {
    color: "#2C6B8F",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "600",
    border: "2px solid #2C6B8F",
    borderRadius: "4px",
    padding: "9px",
    textAlign: "center",
    backgroundColor: "#FFFFFF",
  },
};

export default Header;